@if (visible() && budget(); as b) {
  <div class="budget-banner" [attr.data-tone]="tone()" role="status" aria-live="polite">
    <span class="msg">
      @if (tone() === 'exceeded') {
        Daily AI budget reached — <strong>${{ b.spentUsd | number:'1.2-2' }}</strong>
        of <strong>${{ b.capUsd | number:'1.2-2' }}</strong> ({{ b.percentUsed | number:'1.0-1' }}%).
      } @else {
        Approaching daily AI budget — <strong>${{ b.spentUsd | number:'1.2-2' }}</strong>
        of <strong>${{ b.capUsd | number:'1.2-2' }}</strong> ({{ b.percentUsed | number:'1.0-1' }}%).
      }
      <a routerLink="/settings" class="link">Open Settings</a>
    </span>
    <button type="button" class="close" (click)="dismiss()" aria-label="Dismiss until tomorrow">×</button>
  </div>
}
